export const REACTIONS_MODE = {
  chat: 'chat',
  comments: 'comments',
};
